module.exports = {
    __esModule: true,
    default: function anonymous(props
) {
var out='<div class="'+(props.styles.buttonWrapper)+'"> <button class="'+(props.styles.downloadButton)+' '+(props.styles.controlButton)+'" data-playable-hook="download-button" aria-label="'+(props.texts.label)+'" type="button" tabindex="0"> <div class="'+(props.styles.icon)+'"> <svg viewBox="0 0 24 21" xmlns="http://www.w3.org/2000/svg"> <path d="M11 10.586V0h2v10.825L18.071 6l1.414 1.414-7.085 6.743-.329.328L5 7.415 6.414 6 11 10.586zM0 19h24v2H0v-2z" fill="#FFF" fill-rule="evenodd"/> </svg> </div> </button></div>';return out;
} 
  };